import { Container, ProgressBar } from './LinearProgress.styles'

export interface LinearProgressProps {
  progress: number;
}

const LinearProgress = ({ progress }: LinearProgressProps) => {
  return (
    <Container>
      <ProgressBar $progress={progress} />
    </Container>
  )
}

export default LinearProgress
